import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Stack, Typography, useTheme } from '@mui/material';
import { Mode } from '../components/room/types';

type PropTypes = {
  isAdmin: boolean;
  mode: Mode;
  open: boolean;
  spectate?: boolean;
  unpause: () => void;
  unpauseCount?: number;
};

export const PausedDialog = ({
  isAdmin,
  mode,
  open,
  spectate,
  unpause,
  unpauseCount,
}: PropTypes) => {
  return (
    <Dialog open={open}>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        {!unpauseCount ? (
          <Typography variant="h6">The game has been paused</Typography>
        ) : (
          <Stack spacing={2}>
            <Typography variant="h6">Game is unpausing</Typography>
            <Typography variant="h4" textAlign={'center'}>
              {unpauseCount}
            </Typography>
          </Stack>
        )}
      </DialogContent>
      {!unpauseCount &&
      (!spectate || isAdmin) &&
      (mode === 'solo' || isAdmin) ? (
        <DialogActions>
          <Button onClick={unpause} fullWidth color="warning">
            Unpause
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
